QuantityOnHandFieldController.$inject = ['$scope']
function QuantityOnHandFieldController($scope) {
  const quantityOnHand = $scope.model.QuantityOnHand

  const templateOptions = $scope.to

  const text = quantityOnHand ? quantityOnHand.toString() : '0'
  const label = templateOptions.helpLabel ? templateOptions.helpLabel : 'Max'
  $scope.to.helpText = `${label}: ${text}`
}

export default QuantityOnHandFieldController